import { GenericValue, DynamicContent, Language, HisUploadFile } from 'hisng';
import { Publication } from 'app/fs/res/publication/model/publication';
import { Nomination } from 'app/fs/res/prize-nomination/nomination/model/nomination';
import { ProjectMember, OrganizationProject } from 'app/fs/res/finance/model/project/project-classes';
import { ResearchContract } from 'app/fs/res/common/model/finance/research-contract-classes';

export class Project extends DynamicContent {
    id: number;
    objGuid: string;

    uniquename: string;
    shorttext: string;
    defaulttext: string; // (Title) Not null
    longtext: string;

    referenceNumber: string;

    startdate: string | Date;
    enddate: string | Date;

    parent: Project;

    predecessor: Project;

    projectType: GenericValue;

    projectStatus: GenericValue;
    projectObjective: GenericValue;
    visibilityValue: GenericValue;

    commentary: string;
    isEconomical: GenericValue;

    language: Language;
    lockVersion: number;

    // Pseudonymisierung
    canViewOriginalData: GenericValue;
    isPseudonymized: GenericValue;
    pseudonymizedTitle: string;
    pseudonymizedResearchPartner: string;

    members: ProjectMember[] = [];

    publications: Publication[] = [];

    nominations: Nomination[] = [];

    organizations: OrganizationProject[] = []; // internal/external orgUnits

    researchAreas: GenericValue[] = [];
    researchAreasKdsf: GenericValue[] = [];
    subjectAreas: GenericValue[] = [];

    fundingPrograms: ResearchContract[] = [];

    listviews: Record<string, any>;

    kdsfCategory: GenericValue;

    keyWords: GenericValue[];

    stillAvailableDetails: boolean; // read only
    kdsfCategoryDetails: boolean; // read only

    documents: HisUploadFile[] = [];

    // Map von Sprachcodes zu "hisAttribute"-Schlüssel-Werte-Paaren. Beispiele:
    // {
    //     en: {
    //         nameTitle: 'Patent: Verfahren zur Berechnung der Staatsfinanzen basierend auf Blockchain-Technologie',
    //         details: 'Priority patent | granted | 12/20/2019',
    //         title: 'Patents'
    //     }
    // };
    //
    // {
    //     en: {
    //         longtext: 'Englisch',
    //         shorttext: 'en',
    //          defaulttext: 'en'
    //     },
    //     fr: {
    //         longtext: 'französisch',
    //         shorttext: 'fr',
    //         defaulttext: 'fr'
    //     }
    // };
    // tslint:disable-next-line: variable-name
    _foreigntext: Record<string, Record<string, string>>;

    constructor(
        id?: number,
        defaulttext?: string,
        members?: ProjectMember[],
        kdsfCategory?: GenericValue
    ) {
        super();
        this.id = id;
        this.defaulttext = defaulttext;
        this.members = members;
        this.kdsfCategory = kdsfCategory;
    }
}

export class SimpleProject {
    id: number;
    defaulttext: string;
}
